import React from "react";
import Headline from "./Headline";
import PostsApi from "../../api-services/posts-api.service";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const bannerPath = '/iceholidays-assets/images/whatsnew_cover.png';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} searchParams={useSearchParams()}/>;
}

class WhatsNewShowPage extends React.Component <{params, searchParams}>  {
  postsApi = new PostsApi;

  state = {
    breadcrumbs: [
      { title: <Link to='/web'>Home</Link> },
      { title: <Link to='/web/new-posts'>What's new</Link> }
    ],
    header: "What's new",
    blog: {title: "", thumbnail: "", content: ""},
  }

  componentDidMount() {
    this.postsApi.getPost(this.props.params.id)
      .then(blogData => {
        var breadcrumbs = this.state.breadcrumbs;
        breadcrumbs.push({title: <span>{blogData.title}</span>});
        this.setState({blog: blogData, breadcrumbs})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading post.'});
      });
  }


  render(){
    const {blog, header} = this.state;
    return (
      <div id="news-blogs-show" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={this.state.breadcrumbs}>
          <span className="title">
              {header}
            </span>
        </Headline>

        <div className="gd-series-tour-show-page_body">
          <h1>{blog.title}</h1>
          <img src={blog.thumbnail}/>
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
    )
  }
}


export default withParams(WhatsNewShowPage);